import type { RemoveTagAction as RemoveTagActionType } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";
import { RuleTagPicker } from "../../rule-tag-picker";

export const RemoveTagAction = memo(function RemoveTagAction({
  action,
  onChange,
  editableFields,
}: {
  action: RemoveTagActionType;
  onChange: (updated: RemoveTagActionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const { t } = useTranslation();
  const tagEditable = editableFields === undefined || editableFields.has("tag");

  const tagNames = useMemo(() => {
    if (Array.isArray(action.tag)) {
      return action.tag;
    }
    return action.tag ? [action.tag] : [];
  }, [action.tag]);

  return (
    <Flex dir="column" gap="sm" w="full">
      <Flex
        style={
          tagEditable ? undefined : { pointerEvents: "none", opacity: 0.6 }
        }
      >
        <RuleTagPicker
          addButtonLabel={t("Remove tag")}
          onChange={(names) => onChange({ ...action, tag: names })}
          selectedTagNames={tagNames}
        />
      </Flex>
    </Flex>
  );
});
